import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface DocumentPackDocumentReorderPatchOptions {
  newPosition: number;
}

export function documentPackDocumentReorderApi(path: string) {
  return {
    path,
    PATCH: (params: DocumentPackDocumentReorderPatchOptions) =>
      api.patch<JsonApiResponse>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
